rkcApp.config(['$mdThemingProvider', 'ssSideNavSectionsProvider', function ($mdThemingProvider: any, ssSideNavSectionsProvider: any) {
    var customPrimaryForSidebar = {
        '50': '#000',
        '100': '#F2F2F2',
        '200': '#F2F2F2',
        '300': '#F2F2F2',
        '400': '#F2F2F2',
        '500': '#F2F2F2',
        '600': '#ddd',
        '700': '#F2F2F2',
        '800': '#ddd',
        '900': '#F2F2F2',
        'A100': '#727272',
        'A200': '#F2F2F2',
        'A400': '#F2F2F2',
        'A700': '#F2F2F2'
    };

    $mdThemingProvider.definePalette('customPrimaryForSidebar', customPrimaryForSidebar);

    $mdThemingProvider.theme('main').primaryPalette('indigo').accentPalette('teal', { 'default': '700'});
    $mdThemingProvider.theme('sidebar').primaryPalette('customPrimaryForSidebar', {  'default': '700'  });

    $mdThemingProvider.setDefaultTheme('main');

    ssSideNavSectionsProvider.initWithTheme($mdThemingProvider);

}]);


/** WEBPACK FOOTER **
 ** ./src/app/colorConfig.ts
 **/